import gsap from 'gsap';

export const bounceIn = {
  mounted(el, binding) {
    const duration = binding.value?.duration || 0.5;
    const delay = binding.value?.delay || 0;
    const scale = binding.value?.scale || 0.3;
    const trigger = binding.value?.trigger || 'top bottom-=100';

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;

    if (!prefersReducedMotion) {
      gsap.from(el, {
        scale: scale,
        opacity: 0,
        duration: duration,
        delay: delay,
        ease: 'back.out(1.7)',
        clearProps: 'all',
        scrollTrigger: {
          trigger: el,
          start: trigger,
          toggleActions: 'play none none none',
        },
      });
    }
  },
};
